module.exports = __webpack_public_path__ + "static/media/depths-player-login-bg.a7cb04f5.jpg";